import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'

function AddOrEditType(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: null,
        loading: false,
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: []
            }))
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                loading: false
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            Api.get(`contractors/types/find?id=${popup.editId}`)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        data: res.data,
                    }))
                })
        }

    }, [popup.edit])


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)

        setValidations(null)
    }

    const handleSave = e => {
        e.preventDefault()


        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'contractors/types/addedit'

        let data = new FormData(e.target)

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide(e)

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }



    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary medium`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {popup.edit ? trans('headings.editType') : trans('headings.addType')}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="popup-container">
                    <div className="col" style={{ width: 'auto' }}>
                        <label>
                            {trans('labels.color')}
                        </label>
                        <input
                            type="color"
                            name="color"
                            className={validations && validations.color ? 'validate' : ''}
                            defaultValue={popup.data?.color ? popup.data?.color : ''}
                            style={{
                                border: "none",
                                padding: 0,
                            }}
                        />
                    </div>
                    <div className="col">
                        <label>
                            {trans('labels.name')}
                        </label>
                        <input
                            type="text"
                            name="name"
                            defaultValue={popup.edit && popup.data ?
                                (popup.data?.translation?.name || popup.data.name)
                                :
                                ''
                            }
                            className={validations && validations.name ? 'validate' : ''}
                        />
                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(AddOrEditType)